/* eslint-disable*/
import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import clsx from 'clsx';
import { Bar, Line } from 'react-chartjs-2';
import {
  Grid,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@material-ui/core';
import MaterialTable from 'material-table';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import useDashboard from '../../../../hooks/useDashboard';

/* Modal */
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import useStyles from '../../Main.style';

export const optionsForTotalActivities = {
  indexAxis: 'y', //as const,
  elements: {
    bar: {
      borderWidth: 2,
    },
  },
  responsive: true,
  plugins: {
    legend: {
      display: false, // as const,
    },
    title: {
      display: true,
      text: '',
    },
  },
};
const CellWorkLoadNumbers = ({
  managementMyCellListFromMyCell,
  clientComplexityScoreFromMyCell,
  totalOperationsFromMyCell,
}) => {
  /* Modal */
  const key = 'iFrasCwdJh';
  const userCookie = Cookies.get('user');
  const bytes = CryptoJS.AES.decrypt(userCookie, key);
  const loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  const [totalOperations, setTotalOperations] = useState([]);

  const theme = useTheme();
  const {
    getFileManagementMyCellTable,
    getTotalOperations,
    getClientComplexityScoreTable,
  } = useDashboard();
  const [totalFileCellListData, setTotalFileCellListData] = useState([]);
  const [totalFileCellListValueData, setTotalFileCellListValueData] = useState([]);

  const [clientComplexityScore, setClientComplexityScore] = useState([]);
  const loadTotalOps = async () => {
    const totalOps = totalOperationsFromMyCell;
    setTotalOperations(totalOps?.usersResult);
  };
  const loadManagementMyCellList = async () => {
    const managementMyCellList = managementMyCellListFromMyCell;
    setTotalFileCellListData(managementMyCellList?.totalFileCellList);
    setTotalFileCellListValueData(managementMyCellList?.totalFileCellListValue);
  };

  const loadClientComplexityScoreTable = async () => {
    const clientComplexityScoreTableData = clientComplexityScoreFromMyCell;
    setClientComplexityScore(clientComplexityScoreTableData?.clientData);
  };

  const dataForTotalActivities = {
    labels: totalFileCellListData || [],
    datasets: [
      {
        data: totalFileCellListValueData || [],
        backgroundColor: '#A6CEE3',
      },
    ],
  };

  useEffect(() => {
    loadManagementMyCellList();
    loadClientComplexityScoreTable();
  }, []);

  useEffect(() => {
    loadTotalOps();
  }, []);

  const isMobile = useMediaQuery(theme.breakpoints.down('xs'), {
    defaultMatches: true,
  });

  const classes = useStyles();
  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12}></Grid>
        <Grid item xs={12} className={classes.innercontent}>
          <Grid container style={{ height: '100%' }}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="h5">Workload in Numbers</Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Box className={classes.innercontentWhite}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography variant="h5" noWrap>
                        TOTAL ACTIVE FILES
                      </Typography>
                    </Box>
                    <Box mt={1}>
                      <Bar
                        options={optionsForTotalActivities || []}
                        data={dataForTotalActivities || []}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <Box className={classes.innercontentWhite}>
                    <Box display="flex" justifyContent="space-between" mb={2}>
                      <Typography variant="h5" noWrap>
                        CLIENT COMPLEXITY SCORE
                      </Typography>
                    </Box>
                    <MaterialTable
                      style={{ boxShadow: 'none' }}
                      className={classes.materialDT}
                      options={{
                        toolbar: false,
                        draggable: false,
                        paging: false,
                        sorting: true,
                        pageSize: 20,
                        pageSizeOptions: [10, 20, 50, 100],
                        showTextRowsSelected: false,
                        toolbarButtonAlignment: 'right',
                        showFirstLastPageButtons: false,
                        actionsColumnIndex: -100,
                        emptyRowsWhenPaging: false,
                      }}
                      localization={{
                        pagination: {
                          labelRowsSelect: 'Rows',
                          labelRowsPerPage: 'Rows Per Page',
                        },
                      }}
                      title="CLIENT COMPLEXITY SCORE"
                      columns={[
                        {
                          title: 'Client Complexity Index',
                          field: 'client',
                          render: (data) => data?.client,
                        },
                        {
                          title: 'Average',
                          field: 'myresult',
                          render: (data) => data?.complexity || 100,
                        },
                        {
                          title: 'Form',
                          field: 'myrank',
                          render: (data) => data?.myrank || 'Form',
                        },
                      ]}
                      data={clientComplexityScore?.slice(0, 5) || []}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box className={classes.innercontentWhite}>
                    <MaterialTable
                      style={{ boxShadow: 'none' }}
                      className={classes.materialDT}
                      options={{
                        toolbar: false,
                        draggable: false,
                        paging: false,
                        sorting: true,
                        pageSize: 20,
                        pageSizeOptions: [10, 20, 50, 100],
                        showTextRowsSelected: false,
                        toolbarButtonAlignment: 'right',
                        showFirstLastPageButtons: false,
                        actionsColumnIndex: -100,
                        emptyRowsWhenPaging: false,
                      }}
                      localization={{
                        pagination: {
                          labelRowsSelect: 'Rows',
                          labelRowsPerPage: 'Rows Per Page',
                        },
                      }}
                      title="CLIENT COMPLEXITY SCORE"
                      columns={[
                        {
                          title:
                            'Cell ' +
                            loggedInUserData?.cell?.cellTitle +
                            ' - ' +
                            new Date().getFullYear() +
                            ' YTD',
                          field: 'metrix',
                          render: (data) => data?.metrix,
                        },
                        {
                          title: 'My Cell YTD',
                          field: 'myresult',
                          render: (data) =>
                            data?.myCell.includes('(') ? (
                              <Typography className={classes.TableTextRed}>
                                {data?.myCell}
                              </Typography>
                            ) : (
                              data?.myCell
                            ),
                        },
                        {
                          title: 'Ranking',
                          field: 'rank',
                          render: (data) => (
                            <span
                              className={
                                data?.rank == Math.max(...totalOperations.map((o) => o?.rank))
                                  ? classes.vectorRankingRed
                                  : data?.rank == 1
                                  ? classes.vectorRankingGreen
                                  : classes.vectorranking
                              }
                            >
                              {data?.rank}
                            </span>
                          ),
                        },
                        {
                          title: 'Top Cell YTD',
                          field: 'myrank',
                          render: (data) =>
                            data?.highest.includes('(') ? (
                              <Typography className={classes.TableTextRed}>
                                {data?.highest}
                              </Typography>
                            ) : (
                              data?.highest
                            ),
                        },
                        {
                          title: "Vector's Average",
                          field: 'average',
                          render: (data) =>
                            data?.average.includes('(') ? (
                              <Typography className={classes.TableTextRed}>
                                {data?.average}
                              </Typography>
                            ) : (
                              data?.average
                            ),
                        },
                      ]}
                      data={totalOperations || []}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}></Grid>
      </Grid>
    </>
  );
};

export default CellWorkLoadNumbers;
